import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { TokenAtom, isLoginSelector } from './Recoil/TokenAtom';


import { useSelector , useDispatch } from 'react-redux';
import { clearLoginInfo } from './store/userSlice';


import common from './common';
import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Header({ openLoginModal, menuSet }) {
	const navigate = useNavigate();
	const setAccessToken = useSetRecoilState(TokenAtom);
	const isLogin = useRecoilValue(isLoginSelector); // 로그인 상태 가져오기
	const [activeMenu, setActiveMenu] = useState(null);
	const [isMypageVisible, setIsMypageVisible] = useState(false);
	const [moNavOpen, setMoNavOpen] = useState(null);
	
	// 리덕스에서 로그인 인포를 받아옴
    const dispatch = useDispatch();

	const social_fb_link='https://www.facebook.com/yehs.naek';
	const social_yt_link='https://www.youtube.com/channel/UCgvk9fEkwuWbVOK4z12_qRw';
	const social_ig_link='https://www.instagram.com/yehs.naek/?hl=en';


	const { pToast, useAlert, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
	
	
	

	const toggleMypage = () => {
		setIsMypageVisible(!isMypageVisible);
	};

	const handleLogout = async (e) => {

		e.preventDefault();

		try {
			pLoadingOn();
			const response = await axios.post(`${API_BASE_URL}/yehs_login/out/logout`, {} , {
				withCredentials: true
			});

			if (response.data.result === 't') {
				dispatch(clearLoginInfo());
				setAccessToken(undefined);
				sessionStorage.removeItem('accessToken'); // sessionStorage 토큰 제거
				navigate('/');
			} else {
				pAlert(response.data.msg);
			}
		} catch (error) {
			console.error('Data fetching failed:', error);
		} finally {
			pLoadingOff();
		}

		
	};

	const handleMouseEnter = (menu) => {
		// setActiveMenu(menu);
		const moNavWrapSlide = document.querySelector('.mo_nav_wrap_slide');
        if (moNavWrapSlide && moNavWrapSlide.classList.contains('open')) {
			//
        }else{
			setActiveMenu(menu);
		}
	};

	const handleMouseLeave = () => {
		// setActiveMenu(null);
		const moNavWrapSlide = document.querySelector('.mo_nav_wrap_slide');
        if (moNavWrapSlide && moNavWrapSlide.classList.contains('open')) {
			//
        }else{
			setActiveMenu(null);
		}
	};

	const handleLinkClick = () => {
		setActiveMenu(null);
		const moNavWrapSlide = document.querySelector('.mo_nav_wrap_slide');
		const navBg = document.querySelector('.mo_nav_bg');
        if (moNavWrapSlide && moNavWrapSlide.classList.contains('open')) {
            moNavWrapSlide.classList.remove('open');
            navBg.classList.remove('open');
        }
	};
	const handleMoNavArrowClick = (menu) => {
		if (activeMenu === menu) {
			const subMenu = document.querySelector('.submenu');
			if(subMenu){
				subMenu.classList.remove('open');
			}
            const timer = setTimeout(() => {
                setActiveMenu(null);
            }, 0); // 1초 딜레이
            return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 클리어
		}else{
			setActiveMenu(menu);
		}
	};
    useEffect(() => {
		if( activeMenu !== null){
            const timer = setTimeout(() => {
                const subMenu = document.querySelector('.submenu');
                if (subMenu) {
                    subMenu.classList.add('open');
                }
            }, 0); // 1초 딜레이
            return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 클리어
		}
    }, [activeMenu]);
	
	const toggleMoGnb = () => {
		// setMoNavOpen(!moNavOpen);
		const moNavWrapSlide = document.querySelector('.mo_nav_wrap_slide');
		const navBg = document.querySelector('.mo_nav_bg');
	
		if (moNavWrapSlide.classList.contains('open')) {
		    moNavWrapSlide.classList.remove('open');
		    navBg.classList.remove('open');
		} else {
		    moNavWrapSlide.classList.add('open');
		    navBg.classList.add('open');
		}
	};

	
	return (
		<>
		<AlertComponent/>
		<ConfirmComponent/>
		<LoadingComponent/>
		<header className="header_wrap">
			<div className="header_top_box">
				<ul className="hd_top_right ">
					<div className="menu_wrap display_flex">
						{isLogin ? (
							<li className="islogin_wrap">
								<ul className='islogin_box display_flex'>
									<li className='login_li'>
										{/* <button onClick={toggleMypage}>마이페이지</button> */}
										<Link to={'/mypage'} onClick={() => setIsMypageVisible(false)}>내 정보</Link>
										{/* {isMypageVisible && (
											<ul className='mypage_wrap'>
												<li className='mypage_li'>
													<Link to={'/mypage'} onClick={() => setIsMypageVisible(false)}>내 정보</Link>
												</li>
											</ul>
										)} */}
									</li>
									<li><button onClick={handleLogout} className="logout_btn">로그아웃</button></li>
								</ul>
							</li>
						) : (
							<>
								<li>
									<button onClick={openLoginModal} className="login_btn">로그인</button>
								</li>
								<li>
									<Link className='login_btn' to={'/findIdPw'}>ID / PW 찾기</Link>
									{/* <button onClick={openLoginModal} className="login_btn">ID / PW 찾기</button> */}
								</li>
							</>
						)}
						
						
						<li>
							<a className='hd_social_btn' href={social_fb_link} target="_blank" >
								<img className='hd_social_img' src='/img/hdface.png' alt='facebook'></img>
							</a>
						</li>
						<li>
							<a className='hd_social_btn' href={social_ig_link} target="_blank" >
								<img className='hd_social_img' src='/img/hdinsta.png' alt='facebook'></img>
							</a>
						</li>
						<li>
							<a className='hd_social_btn' href={social_yt_link} target="_blank" >
								<img className='hd_social_img' src='/img/hdyoutube.png' alt='facebook'></img>
							</a>
						</li>
					</div>
				</ul>
			</div>
			
			<div className="header_bot_box">
				<div className='hd_logo_box'>
					<Link className='hd_logo_btn' to={'/'}>
						<img className='hd_logo' src='/img/hdlogo.png'></img>
					</Link>
				</div>
				<Link className='mo_nav_btn' onClick={toggleMoGnb}>
					<span></span>
					<span></span>
				</Link>
				<div className={`mo_nav_bg ${moNavOpen ? 'open' : ''}`} onClick={toggleMoGnb}></div>
				<div className={`mo_nav_wrap_slide ${moNavOpen ? 'open' : ''}`}>
					<div className='mo_nav_top_box'>
						<Link className='mo_nav_close_btn' onClick={toggleMoGnb}>
						</Link>
						<div className='mo_nav_top_info_box'>
							{isLogin ? (
								<>
									<Link className='mo_n_t_i_btn mo_n_t_i_logout' onClick={handleLogout}>로그아웃</Link>
									<Link className='mo_n_t_i_btn mo_n_t_i_mypage' to={'/mypage'} onClick={() => setIsMypageVisible(false)}>내 정보</Link>
								</>
							) : (
								<>
									<Link className='mo_n_t_i_btn mo_n_t_i_login' onClick={(e) => {openLoginModal(e);handleLinkClick(e);}}>로그인</Link>
									<Link className='mo_n_t_i_btn mo_n_t_i_idpwfind' to={'/findIdPw'} onClick={handleLinkClick}>ID / PW 찾기</Link>
								</>
							)}
							<a className='mo_n_t_i_social' href={social_fb_link} target="_blank" >
								<img className='mo_n_t_i_s_img' src='/img/hdface.png' alt='facebook'></img>
							</a>

							<a className='mo_n_t_i_social' href={social_ig_link} target="_blank" >
								<img className='mo_n_t_i_s_img' src='/img/hdinsta.png' alt='facebook'></img>
							</a>

							<a className='mo_n_t_i_social' href={social_yt_link} target="_blank" >
								<img className='mo_n_t_i_s_img' src='/img/hdyoutube.png' alt='facebook'></img>
							</a>
						</div>
					</div>
					<ul className='hd_nav_box mo_nav_wrap' onMouseLeave={handleMouseLeave}>

						
						{
							menuSet.map((item) => (
								<li className='nav_1_li' key={item.idTxt}>
									<Link className={`nav_1_btn_arrow ${activeMenu === item.idTxt ? 'open' : ''}`} onClick={() => handleMoNavArrowClick(item.idTxt)}></Link>
									<Link className='nav_1_btn' to={item.link} onMouseEnter={() => handleMouseEnter(item.idTxt)} onClick={handleLinkClick}>{item.name}</Link>
									{activeMenu === item.idTxt && item.subMenu && (
										<ul className="submenu">
											{item.subMenu.map((subItem) => (
												<li className="nav_2_li" key={subItem.id}>
													<Link className='nav_2_btn' to={subItem.link} onClick={handleLinkClick}>{subItem.name}</Link>
												</li>
											))}
										</ul>
									)}
								</li>
							))
						}
					</ul>
				</div>
			</div>
		</header>
		</>
		
	);
}

export default Header;
